import { UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const atLeastOne = (validator: ValidatorFn, controls: string[] | null = null) => (
  group: UntypedFormGroup,
): ValidationErrors | null => {
  if (!controls) {
    controls = Object.keys(group.controls);
  }

  const hasAtLeastOne = group && group.controls && controls
    .some(k => !validator(group.controls[k]));

  controls.forEach(c => {
    group.get(c)?.setErrors({ atLeastOne: null });
    group.get(c)?.updateValueAndValidity({ onlySelf: true, emitEvent: false });
  });
  if (!hasAtLeastOne) {
    controls.forEach(c => group.get(c)?.setErrors({ atLeastOne: true }));
  }

  return hasAtLeastOne ? null : {
    atLeastOne: true,
  };
};
